module.exports = __webpack_public_path__ + "static/img/address.5446b274.png";